import axios from 'axios';
import type { PMLesson } from '@/models/pmlesson';
import type { PMSubPhase } from '@/models/pmsubphase';
import type { Tag } from '@/models/tag';

class PMLessonWebservice {
    public load(pmSubPhaseId: number, exclude_lesson_id: number | null = null) {
        return axios.get<PMLesson[]>('/pmlessons', {
            params: {
                pmSubPhaseId,
                exclude_lesson_id,
            },
        });
    }

    public loadLessonsByApproved(approved: boolean) {
        return axios.get<PMLesson[]>('/pmlessons/loadLessonsByApproved', {
            params: {
                approved,
            },
        });
    }

    public getById(pmLessonId: number) {
        return axios.get<PMLesson>('/pmlessons/getById', {
            params: {
                pmLessonId,
            },
        });
    }

    public count() {
        return axios.get<number>('/pmlessons/count');
    }

    public countPersonal() {
        return axios.get<number>('/pmlessons/countPersonal');
    }

    // tslint:disable-next-line:max-line-length
    public store(
        pmLesson: PMLesson,
        pmSubPhaseId: number,
        mandatory: boolean = false,
        tags: Tag[],
        userId: number | null = null,
        projectId = 0,
        parentLesson: PMLesson | null = null
    ) {
        const parentId = parentLesson ? parentLesson.id : null;
        return axios.post('/pmlessons/store', {
            insight: pmLesson.insight,
            more_info: pmLesson.more_info,
            pmSubPhaseId,
            mandatory,
            tags: tags.map((tag) => tag.id),
            userId,
            projectId,
            parentId,
        });
    }

    public storeApproved(pmLesson: PMLesson, approved: boolean) {
        return axios.post('/pmlessons/storeApproved', {
            pmLessonId: pmLesson.id,
            approved,
        });
    }

    public update(
        pmLesson: PMLesson,
        pmSubPhase: PMSubPhase,
        mandatory: boolean = false,
        tags: Tag[],
        projectId = 0,
        parentLesson: PMLesson | null = null
    ) {
        const parentId = parentLesson ? parentLesson.id : null;
        return axios.post('/pmlessons/update', {
            id: pmLesson.id,
            insight: pmLesson.insight,
            more_info: pmLesson.more_info,
            pmSubPhaseId: pmSubPhase.id,
            mandatory,
            tags: tags.map((tag) => tag.id),
            projectId,
            parentId,
        });
    }

    // noinspection JSUnusedGlobalSymbols
    public updateOrder(lesson: PMLesson, direction: string = 'up') {
        return axios.post('/pmlessons/update/order', {
            id: lesson.id,
            direction,
        });
    }

    public remove(pmLesson: PMLesson) {
        return axios.post('/pmlessons/remove', {
            id: pmLesson.id,
        });
    }
}

export const pmLessonWebservice = new PMLessonWebservice();
